/* Keep floating marketing controls clear of purchase controls and modal content. */
(() => {
  const body = document.body;
  const purchaseSelector = '.product-area [name="add"], .product-area .klaviyo-bis-trigger';
  const modalSelector = 'dialog, [role="dialog"], [aria-modal="true"], .theme-modal, .cc-popup, #colorbox, #klaviyo-bis-iframe';
  const purchaseVisibility = new Map();
  const modals = new Set();
  let pending = false;

  const purchaseObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => purchaseVisibility.set(entry.target, entry.isIntersecting));
    body.classList.toggle('purchase-controls-in-view', [...purchaseVisibility].some(([node, visible]) => node.isConnected && visible));
  });

  function updateModals() {
    pending = false;
    let open = body.classList.contains('modal-active');
    modals.forEach(node => {
      if (!node.isConnected) { modals.delete(node); return; }
      if (node.matches('dialog') && !node.open) return;
      if (node.getAttribute('aria-hidden') === 'true' || node.hidden) return;
      // Some drawers have a zero-height wrapper around a fixed-position panel.
      if (node.getAttribute('aria-hidden') === 'false' && node.getAttribute('aria-modal') === 'true') { open = true; return; }
      const style = getComputedStyle(node);
      const rect = node.getBoundingClientRect();
      if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < innerWidth && rect.top < innerHeight) open = true;
    });
    body.classList.toggle('floating-controls-modal-open', open);
  }
  function scheduleModals() {
    if (!pending) { pending = true; requestAnimationFrame(updateModals); }
  }
  const modalObserver = new MutationObserver(scheduleModals);
  function register(root) {
    if (!(root instanceof Element)) return;
    const purchases = root.matches(purchaseSelector) ? [root] : [];
    purchases.push(...root.querySelectorAll(purchaseSelector));
    purchases.forEach(node => {
      if (!purchaseVisibility.has(node)) { purchaseVisibility.set(node, false); purchaseObserver.observe(node); }
    });
    const dialogs = root.matches(modalSelector) ? [root] : [];
    dialogs.push(...root.querySelectorAll(modalSelector));
    dialogs.forEach(node => {
      if (!modals.has(node)) {
        modals.add(node);
        modalObserver.observe(node, { attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'style', 'class'] });
      }
    });
    if (dialogs.length) scheduleModals();
  }
  register(body);
  modalObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(records => {
    let removed = false;
    records.forEach(record => {
      record.addedNodes.forEach(register);
      if (record.removedNodes.length) removed = true;
    });
    if (removed) {
      purchaseVisibility.forEach((_, node) => {
        if (!node.isConnected) { purchaseObserver.unobserve(node); purchaseVisibility.delete(node); }
      });
      body.classList.toggle('purchase-controls-in-view', [...purchaseVisibility.values()].some(Boolean));
      scheduleModals();
    }
  }).observe(body, { childList: true, subtree: true });
  // Visibility may finish transitioning after the opening class is set.
  window.addEventListener('resize', scheduleModals, { passive: true });
  document.addEventListener('transitionend', event => { if (event.target.matches(modalSelector)) scheduleModals(); });
  document.addEventListener('animationend', event => { if (event.target.matches(modalSelector)) scheduleModals(); });
})();
